import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaRupeeSign, FaUsers, FaUserTie, FaGraduationCap, FaBriefcase } from 'react-icons/fa';
import './FeeStructure.css';

const FeeStructure = () => {
  const navigate = useNavigate();
  const feeData = [
    {
      category: 'PG Students & Research Scholars & Postdocs & Research Associates',
      icon: <FaGraduationCap />,
      regular: 750,
      late: 1500,
      color: 'rgb(52, 152, 219)'
    },
    {
      category: 'Faculty from Academia',
      icon: <FaUsers />,
      regular: 1000,
      late: 2000,
      color: 'rgb(46, 204, 113)'
    },
    {
      category: 'Industry & R&D Representatives',
      icon: <FaUserTie />,
      regular: 1500,
      late: 3000,
      color: 'rgb(155, 89, 182)'
    }
  ];

  return (
    <div className="fee-structure-page">
      

      <div className="fee-structure-container">
        

        <div className="fee-table-wrapper">
          <div className="fee-cards-grid">
            {feeData.map((item, index) => (
              <div key={index} className="fee-card" style={{ borderTopColor: item.color }}>
                <div className="fee-card-icon" style={{ color: item.color }}>
                  {item.icon}
                </div>
                <h3 className="fee-card-category">{item.category}</h3>
                <div className="fee-card-details">
                  <div className="fee-row">
                    <span className="fee-label">Regular Registration</span>
                    <span className="fee-amount regular">₹{item.regular}</span>
                  </div>
                  <div className="fee-row">
                    <span className="fee-label">Late Registration</span>
                    <span className="fee-amount late">₹{item.late}</span>
                  </div>
                  <div className="fee-row-discount">
                    <span className="discount-text">
                      Late fee is double the regular fee
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>

         

          <div className="fee-notes">
            <h3 className="fee-notes-title">Instructions for Registration</h3>
            <ul className="fee-notes-list">
              <li><strong>Payment Required:</strong> Registration fee must be paid in full before registering the conference.</li>
              <li><strong>Proof of Payment:</strong> Save your payment reference number and attach proof of payment during registration.</li>
              <li>
                <strong>Register:</strong> Register for the conference using the following link.<button className="fee-blinky-button" onClick={() => navigate('/login')}>Register Now</button>.
                <ul className="fee-notes-list fee-nested-list">
                  <li><strong>Already Submitted Abstract:</strong> If you have already submitted an abstract, use the same login credentials for registration.</li>
              <li><strong>First Time Registration:</strong> If you have not submitted an abstract but want to register as a participant, sign in and register for the conference.</li>
              </ul>
              </li>
              <li><strong>Perks:</strong> Conference registration includes access to all keynote presentations, invited talks, oral and poster sessions, conference proceedings.</li>
              <li><strong>Refreshments:</strong> Registration also includes food (Breakfast,Lunch & Dinner) and refreshments during the conference.</li>
              <li><strong>Accommodation:</strong> Accommodation charges are separate from registration fees.</li>
              
            </ul>
          </div>

         
        </div>
      </div>
    </div>
  );
};

export default FeeStructure;
